/**
 * Middleware for checking app-view parameter
 */

/* eslint-disable */
export default function({ store, req, query }) {
  const isAppView = query['appView'] === '1';
  store.commit('setIsAppView', isAppView);
}
